import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    PieChartDynamicStyleType,
    PieChartMeasures
} from "./type";

export const PIE_CHART_MAX_SLICES = 6;

export const PIE_CHART_LEGEND_MIN_RATIO = 1;

export const getPieChartMeasures = ({
    shapeConfigs,
    typography,
    borders,
    spaces
}: {
    spaces: NCoreUIKit.ActivePalette["spaces"];
    shapeConfigs: NCoreUIKit.ShapeConfigs;
    typography: NCoreUIKit.Typography;
    borders: NCoreUIKit.Borders;
}): PieChartMeasures => {
    return {
        gap: Math.max(shapeConfigs.chartSegmentGap, borders.subtract),
        valueTypography: typography.titleLargeSize,
        labelTypography: typography.bodySmallSize,
        ratio: shapeConfigs.chartDonutRatio,
        centerClearance: spaces.spacingSm,
        lift: spaces.spacingXs
    };
};

const stylesheet = StyleSheet.create({
    container: {
        width: "100%"
    },
    plot: {
        flexShrink: 0
    }
});

export const useStyles = ({
    plotHeight,
    isBeside,
    colors,
    spaces
}: PieChartDynamicStyleType) => {
    const styles = {
        root: {
            alignItems: isBeside ? "center" : undefined,
            flexDirection: isBeside ? "row" : "column",
            gap: spaces.spacingMd
        } as ViewStyle,
        value: colors.content.text.high,
        label: colors.content.text.low,
        plot: isBeside ? {
            width: plotHeight
        } as ViewStyle : undefined,
        legend: isBeside ? {
            flex: 1
        } as ViewStyle : undefined
    };

    return styles;
};
export default stylesheet;
